import { Button, ButtonProps } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";

interface CustomButtonProps extends ButtonProps {
  text: string;
  backgroundColor?: string;
  textColor?: string;
  fontSize?: string | Record<string, string>;
  fontWeight?: string | number;
  onClick?: () => void;
}

// Hover/active dla naszych głównych kolorów (spójnie z buttonami z hero).
const HOVER: Record<string, { hover: string; active: string }> = {
  accent: { hover: "#c41a3a", active: "#a8152f" },
  primary: { hover: "#36007a", active: "#2c0066" }
};

export const CustomButton: React.FC<CustomButtonProps> = observer(
  ({ text, onClick, backgroundColor = "accent", textColor = "white", fontSize = "16px", fontWeight = "700", ...props }) => {
    const tone = HOVER[backgroundColor];

    return (
      <Button
        onClick={onClick}
        bg={backgroundColor}
        color={textColor}
        h="auto"
        py="13px"
        px={{ base: "24px", md: "32px" }}
        borderRadius="12px"
        fontSize={fontSize}
        fontWeight={fontWeight}
        textTransform="none"
        boxShadow={backgroundColor === "accent" ? "0 8px 20px rgba(229,31,68,0.22)" : undefined}
        _hover={tone ? { bg: tone.hover } : { opacity: 0.9 }}
        _active={tone ? { bg: tone.active } : { opacity: 0.85 }}
        {...props}
      >
        {text}
      </Button>
    );
  }
);
